<template>
    <div class="p-fluid custom-input-text" :style="'width: ' + width + 'px;'">
        <label :for="name" class="visually-hidden">{{ label }}</label>
        <InputText :id="name" type="text" v-model="internalValue" :disabled="disabled"
                   :class="computedClasses" @input="handleChange" @blur="handleBlur"
                   :placeholder="label" />
        <span v-show="errorMessage" class="p-invalid">{{ errorMessage }}</span>
    </div>
</template>

<script>
    import InputText from "primevue/inputtext";
    import {useField} from "vee-validate";

    export default {
        name: "CustomInputText",

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            width: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            rules: undefined,
            modelValue: null,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },

            computedClasses() {
                return this.errorMessage ? "p-invalid" : "";
            },
        },

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },

        components: {InputText},
    };
</script>

<style scoped>
    .custom-input-text {
        margin-bottom: 10px;
    }
</style>
